/* eslint-disable react/prop-types */
import React, { useState, useEffect, useRef } from 'react';
import _ from 'lodash';
import { Link, useLocation } from 'react-router-dom';
import QueryString from 'query-string';
import Modal from '@tds/community-modal';
// import EmailShare from 'react-email-share-link';
import PropTypes from 'prop-types';
import styles from '../../assets/css/style';
import { css } from 'styled-components';
import Help from '../help';
import { HeaderButton } from './css';
import axios from 'axios';
import { apiHost, defectManagementConfig, DEFECTS_ACCESS_TOKEN } from '../utils/request';
import {
  localeEnglish,
  localeFrench,
  wirelessOrderForm,
  wirelineAndSecureBusinessForm,
  landingPageForm
} from '../utils/constant';
import { useLocaleActionsContext } from '../context/LocaleContext';
import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';
import EN from '../../EN.json';
import FR from '../../FR.json';
import {
  getContentfulData,
  contentfulFormConfig,
  getData
} from '../contentful';
import { localeEn, localeFr } from '../misc';
import history from '../history';

const onClickLogout = () => {
  localStorage.clear();
  window.location.reload();
};

const Menu = ({ locale, userRights, profile }) => {
  const setLocale = useLocaleActionsContext();
  const localizedStrings = useLocalizedStringsContext();
  const [isModalOpen, setModalOpen] = useState(false);
  const [showHelpSection, setShowHelpSection] = useState(false);
  const ischangePassword = localStorage.getItem('changePassword') === 'true';
  const routerLocation = useLocation();

  const {
    location: { search }
  } = history || {};
  const query = QueryString.parse(search);
  const provinceValue =
    localStorage.getItem('province') === 'AB' ||
    localStorage.getItem('province') === 'BC';

  const config = {
    ...contentfulFormConfig,
    content_type: 'header',
    locale
  };

  // eslint-disable-next-line
  const [helpLink, setHelpLink] = useState('');
  const {
    switchLocaleModal: {
      modalTitle,
      modalBody,
      modalConfirmButtonLabel,
      modalCancelButtonLabel
    },
    adminLinks: {
      defectmanagment
    }
  } = localizedStrings;
  const {
    headerLinks: { home, help, reportAnIssue, labelLogout, defectManagment, }
  } = locale === 'en-US' ? EN : FR;

  const changeLocale = () => {
    setLocale(locale === localeEn ? localeFr : localeEn);
  };
  const onConfirm = () => {
    setModalOpen(false);
    changeLocale();
    history.push('/');
  };

  const onCloseModal = () => setModalOpen(false);

  useEffect(() => {
    getContentfulData(config)
      .then(res => {
        const headerData = getData(res);
        const link = _.get(headerData, 'helpPdf.fields.file.url', '');
        setHelpLink(link);
        if (
          provinceValue &&
          !history.location.pathname.includes(wirelessOrderForm)
        ) {
          setLocale(localeEn);
        }
      })
      .catch(() => { });
  }, [locale, provinceValue]);

  const focusElementOnClose = useRef(null);
  const checkSwitchToRender = (step, province, isWireline) => {
    if (step === '1' && !province) {
      return true;
    }
    if (province && step !== '1' && isWireline) {
      return false;
    }
    return true;
  };
  const [count, setCount] = useState(0);
  const roleId = _.get(profile, 'role.id', '');
  const fetchNotificationCount = async () => {
    if (roleId === 1) {
      const defectUrl = `${apiHost}/defects/countnotify-admin`;
      const userConfig = defectManagementConfig('get', defectUrl);
      await axios({
        ...userConfig,
      }).then(res => {
        const {
          data: { notificationCount = '' }
        } = res;
        if (notificationCount >= 0) {
          setCount(notificationCount);
        }
      });
    } else {
      const profileId = _.get(profile, 'id')
      if (profileId) {
        const defectUrl = `${apiHost}/defects/countnotify-user/${profileId}`;
        const userConfig = defectManagementConfig('get', defectUrl);
        await axios({
          ...userConfig,
          headers: {
            access_token: DEFECTS_ACCESS_TOKEN,
            'Access-Control-Allow-Origin': '*'
          }
        }).then(res => {
          const {
            data: { notificationCount = '' }
          } = res;
          if (notificationCount >= 0) {
            setCount(notificationCount);
          }
        });
      }
    }
  }
  useEffect(() => {
    fetchNotificationCount()
  })
  return (
    <>
      {userRights && !ischangePassword && (
        <ul style={{
          justifyContent: 'flex-end',
          flex: '1 1 0%',
          marginTop: '5px'
        }}>
          {userRights.isHomeLinkVisible && (
            <li>
              <Link variant="link" to="/">
                {home}
              </Link>
            </li>
          )}
          <li>
            <div>
              <HeaderButton  onClick={() => setShowHelpSection(true)}>
                {help}
              </HeaderButton>
            </div>
          </li>
          <li>
            <Link to={`/${locale}/report-an-issue`}>{reportAnIssue}
              {" "}
              {count > 0 ?
                <sup>
                  <span className="badge badge-pill badge-danger">{count}</span>
                </sup> : ''
              }</Link>
          </li>
          {locale === localeFrench ? (
            <li>
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <Link href="#" onClick={() => setLocale(localeEnglish)}>
                English
              </Link>
            </li>
          ) : (
            <li>
              {checkSwitchToRender(
                query.step,
                provinceValue,
                routerLocation.pathname.includes(
                  wirelineAndSecureBusinessForm
                ) && !routerLocation.pathname.includes(landingPageForm)
              ) && (
                  // eslint-disable-next-line jsx-a11y/anchor-is-valid
                  <Link href="#" onClick={() => setLocale(localeFrench)}>
                    Français
                  </Link>
                )}
            </li>
          )}
          <li>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <Link href="#" onClick={onClickLogout}>
              {labelLogout}
            </Link>
          </li>
        </ul>
      )}
      <Modal
        /* eslint-disable-next-line jsx-a11y/anchor-is-valid */
        heading={modalTitle}
        bodyText={modalBody}
        confirmCTAText={modalConfirmButtonLabel}
        cancelCTAText={modalCancelButtonLabel}
        onConfirm={onConfirm}
        onClose={onCloseModal}
        isOpen={isModalOpen}
        focusElementAfterClose={focusElementOnClose}
      />
      {showHelpSection && (
        <Help guideLink={helpLink} setShowHelpSection={setShowHelpSection} />
      )}
    </>
  );
};

Menu.propTypes = {
  locale: PropTypes.string.isRequired,
  userRights: PropTypes.shape({
    isStatusEditable: PropTypes.bool,
    isUserEditable: PropTypes.bool,
    canAssignOrder: PropTypes.bool,
    isAdminBandVisible: PropTypes.bool,
    isUserPageVisible: PropTypes.bool,
    isSOVDashboardVisible: PropTypes.bool,
    isBulkUploadVisible: PropTypes.bool,
    isHomeLinkVisible: PropTypes.bool
  }).isRequired
};
/* eslint-disable react/prop-types */
export default Menu;
